export default __webpack_public_path__ + "static/media/Ellipsis.eb24acdd.svg";